import { useState } from "react";

import { toast } from "@sorcery/ui";

import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";
import type { CardType } from "~/types/card";
import { api } from "~/utils/trpc";

export const PrimerCard = ({
  slug,
  children,
}: {
  slug: string;
  children: any;
}) => {
  const { openModal } = useModal();
  const [card, setCard] = useState<CardType>();

  const { mutateAsync: fetchCard } = api.card.getBySlugForPrimer.useMutation();

  const handleClick = async () => {
    if (!card) {
      try {
        const card = await fetchCard({ slug });
        if (card) {
          setCard(card);
          openModal(ModalTypeEnum.CARDGALLERY, { card });
        } else {
          toast.error("No card found, it's likely spelt wrong");
        }
      } catch (error) {
        console.error("Failed to fetch card data:", error);
      }
    } else {
      openModal(ModalTypeEnum.CARDGALLERY, { card });
    }
  };

  return (
    <span className="text-primary cursor-pointer hover:underline" onClick={handleClick}>
      {children}
    </span>
  );
};
